/*=========================================================================================
  File Name: moduleAttackState.js
  Description: Attack Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
    attacks: [],
    attackDetails: [],
    webHooks: [],
    droppedEvents:[]
}; 